import React, { useMemo } from "react";
import { getTireTypesAPI } from "services/api/fleet/tires/api";
import { TireType } from "services/api/fleet/tires/types";
import { DataWithPagination } from "services/api";
import { PaginationDirection } from "services/url";
import { Dropdown } from "../Dropdown";
import { DropdownOption } from "../Dropdown/types";
import { TireTypeDropdownProps } from "./types";
import { DropdownCacheKey, useDropdownCache } from "services/hooks/useDropdownCache";

const THIRTY_MINUTES = 30 * 60 * 1000;

const svgIcon = (svg: string) => `data:image/svg+xml,${encodeURIComponent(svg)}`;

const TIRE_TYPE_ICONS: Record<string, string> = {
  S: svgIcon('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><circle cx="10" cy="10" r="10" fill="#eab308"/></svg>'),
  W: svgIcon('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><circle cx="10" cy="10" r="10" fill="#3b82f6"/></svg>'),
  U: svgIcon('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><circle cx="10" cy="10" r="10" fill="#3b82f6"/><path d="M10 0 A10 10 0 0 1 10 20 Z" fill="#eab308"/></svg>'),
};

const TireTypeDropdown: React.FC<TireTypeDropdownProps> = (props) => {
  const {
    name, disabled, required, label, error, value,
    direction, width, height, placeholder, cssClassName, onChange,
  } = props;

  const { data } = useDropdownCache<DataWithPagination<TireType>>(
    DropdownCacheKey.TireTypes,
    () => getTireTypesAPI({
      pageNumber: 1,
      pageSize: 100,
      sort: { sortBy: "name", direction: PaginationDirection.Ascending },
    }),
    THIRTY_MINUTES
  );

  const options: DropdownOption[] = useMemo(
    () => (data?.data ?? []).map((i) => ({
      value: i.id,
      text: i.name,
      image: TIRE_TYPE_ICONS[i.id] ?? undefined,
    })),
    [data]
  );

  return (
    <Dropdown
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      value={value}
      direction={direction}
      width={width}
      height={height}
      options={options}
      onChange={onChange}
      error={error}
      cssClassName={cssClassName}
    />
  );
};

export default React.memo(TireTypeDropdown);
